import { lazy } from "react";
import type { Path } from "react-router-dom";
import { generateEncodedPath } from "../utils/generateEncodedPath";
import type { AppRouteObject } from "../routes";

export type PermissionManagementTab = "tree" | "roles" | "mutex";

export type PermissionManagementParams = {
  realm: string;
  tab?: PermissionManagementTab;
};

const PermissionManagementSection = lazy(
  () => import("./PermissionManagementSection"),
);

/** 深度链接防护在页面内做（canManage → ForbiddenSection），路由面只要求能进管理台 */
export const PermissionManagementRoute: AppRouteObject = {
  path: "/:realm/um-perm",
  element: <PermissionManagementSection />,
  handle: {
    access: "view-realm",
    breadcrumb: (t) => t("permissionManagement"),
  },
};

export const PermissionManagementRouteWithTab: AppRouteObject = {
  ...PermissionManagementRoute,
  path: "/:realm/um-perm/:tab",
};

export const toPermissionManagement = (
  params: PermissionManagementParams,
): Partial<Path> => {
  const path = params.tab
    ? PermissionManagementRouteWithTab.path
    : PermissionManagementRoute.path;

  return {
    pathname: generateEncodedPath(path, params),
  };
};

const routes: AppRouteObject[] = [
  PermissionManagementRoute,
  PermissionManagementRouteWithTab,
];

export default routes;
